import { render, staticRenderFns } from "./aside_menu.vue?vue&type=template&id=37bc0734&scoped=true&"
import script from "./aside_menu.vue?vue&type=script&lang=js&"
export * from "./aside_menu.vue?vue&type=script&lang=js&"
import style0 from "./aside_menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aside_menu.vue?vue&type=style&index=1&id=37bc0734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc0734",
  null
  
)

export default component.exports